import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CartItems.scss';

const CartListHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="cart-list-header">
      <div className="product-column">{t("myCart.headers.products")}</div>
      <div className="column mobile-hide">{t("myCart.headers.period")}</div>
      <div className="price-column mobile-hide">{t("myCart.headers.price")}</div>
      <div className="last-col mobile-hide">{t("myCart.headers.actions")}</div>
    </div>
  );
};

export default CartListHeader;
